import LoginStyles from 'shared/style/loginStyles'

// LoginAdmin uses the shared login styles
const Style = LoginStyles

export default Style
